import { Helmet } from 'react-helmet'

export function Error({ children }) {
  return (
    <main>
      <Helmet title="Erro" titleTemplate="Ecotrace Solutions - %s" />
      {children}
    </main>
  )
}
